// extracted by mini-css-extract-plugin
module.exports = {"newsHeader":"styles_newsHeader__7Ex7v","title":"styles_title__1SZJx"};